import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "role-card"
};
const _hoisted_2 = {
  class: "title-right"
};
const _hoisted_3 = {
  class: "permission-card"
};
const _hoisted_4 = {
  class: "title-right"
};
const _hoisted_5 = {
  class: "role-card"
};
const _hoisted_6 = {
  class: "permission-card"
};
const _hoisted_7 = {
  class: "body-scroll-2"
};
const _hoisted_8 = {
  class: "permission-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Setting = _resolveComponent("Setting");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "title"
  }, {
    default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "title-left"
    }, "角色列表", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
      onClick: $setup.showRoleMng
    }, {
      default: _withCtx(() => [_createVNode(_component_Setting)]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }), _createVNode(_component_el_scrollbar, {
    class: "body-scroll"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tree, {
      ref: "roleTreeRef",
      data: _ctx.roleTrees,
      "node-key": "roleId",
      accordion: "",
      "highlight-current": true,
      props: $setup.roleTreeProps,
      "default-checked-keys": _ctx.defaultCheckedRoleKeys,
      onNodeClick: $setup.checkRole
    }, null, 8, ["data", "props", "default-checked-keys", "onNodeClick"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
    class: "title"
  }, {
    default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "title-left"
    }, "权限列表", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
      onClick: $setup.showPermissionMng
    }, {
      default: _withCtx(() => [_createVNode(_component_Setting)]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }), _createElementVNode("div", _hoisted_5, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "permission-title"
  }, "菜单权限", -1)), _createVNode(_component_el_scrollbar, {
    class: "body-scroll-2"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tree, {
      data: _ctx.permissionTree,
      ref: "treeRef",
      "show-checkbox": "",
      accordion: "",
      "node-key": "id",
      "check-strictly": true,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true,
      onNodeClick: $setup.handleNodeClick,
      onCheckChange: $setup.handleCheck,
      props: $setup.defaultProps
    }, null, 8, ["data", "onNodeClick", "onCheckChange", "props"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_6, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "permission-title"
  }, "操作权限", -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_checkbox_group, {
    modelValue: _ctx.checkedOptList,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.checkedOptList = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allOptList, opt => {
      return _openBlock(), _createBlock(_component_el_checkbox, {
        class: "permission-checkbox",
        label: opt.name,
        key: opt.id,
        disabled: opt.status == '0',
        onChange: val => $setup.optCheckChange(val, opt.id)
      }, null, 8, ["label", "disabled", "onChange"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])])])])])], 64);
}